import { Title } from "~/components";

export const VisitTitle = () => {
  return <Title className="mb-6 font-medium">Visit confirmed!</Title>;
};
